const SelectOption = ({
  placeholder = "Select a option",
  options = [],
  variant = "light",
  value,
  onChange,
  error,
}) => {
  return (
    <>
      <div className="mt-4">
        <select
          onChange={(e) => onChange(e.target.value)}
          value={value}
          id="countries"
          className={`border-[1px] rounded-[0.3rem] transition-all
      ease-in-out duration-100 placeholder-text-seondary-color
       text-text-primary-color focus:border-[#aaaaaa] outline-0 
       font-lato text-[1rem] w-full  ${
         variant === "light" ? "font-normal" : "font-bold "
       } leading-normal  py-[1rem] px-[1.4rem]`}
        >
          <option value={""}>{placeholder}</option>
          {options.map((option, index) => (
            <option key={index} value={option?.value}>
              {option?.label}
            </option>
          ))}
        </select>
        <label className="font-normal text-[0.75rem] text-red-500 bg-white  pt-1 my-0 py-0 font">
          {error}
        </label>
      </div>
    </>
  );
};

export default SelectOption;
